
<script>
import {mapGetters} from "vuex";
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_speed",
    extends: UnitInfo__sensors_default,
    computed:{
        ...mapGetters([
            'getAppUserUnits',
        ]),
        title() {
            return this.$t('Unit.sensors.Speed')
        },
        value() {
            let speed = this.unitLmsg?.speed
            return (speed >= 0) ? (Math.round(speed) + ' ' + this.getAppUserUnits?.speed) : ''
        },
        statusClass(){
            return 'secondary'
        },
        statusIcon(){
            return 'unit_dashboard__check'
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__speed' : false
        }
    },
}
</script>

<style scoped>

</style>